import _keyBy from 'lodash/keyBy';
import {FeedItem, LocationFeedItem} from './feedItems.types';
import {LocationDynamicProp} from '../locationFeedItems/locationFeedItems.enums';

function toLocalFeedItem(feedItem: FeedItem): FeedItem {
  return {
    ...feedItem,
    issues: feedItem.issues || [],
  };
}

function toStoreFeedItem(feedItem: FeedItem): LocationFeedItem {
  if (!feedItem) return feedItem as LocationFeedItem;

  const dynamicPropsDictionary = _keyBy(feedItem.dynamicProps, 'name');

  function getProp(name: LocationDynamicProp) {
    return dynamicPropsDictionary[name]?.value;
  }

  return {
    ...feedItem,
    position: {
      lat: parseFloat(getProp(LocationDynamicProp.Latitude)),
      lng: parseFloat(getProp(LocationDynamicProp.Longitude)),
    },
    address: getProp(LocationDynamicProp.Address) ?? '',
    city: getProp(LocationDynamicProp.City),
    stateCode: getProp(LocationDynamicProp.StateCode),
    stateName: getProp(LocationDynamicProp.StateName),
    countryCode: getProp(LocationDynamicProp.CountryCode),
    countryName: getProp(LocationDynamicProp.CountryName),
    zipCode: getProp(LocationDynamicProp.Zip),
    radius: getProp(LocationDynamicProp.Radius),
    radiusUnits: getProp(LocationDynamicProp.RadiusUnits),
  };
}

export {toStoreFeedItem, toLocalFeedItem};
